
Array.prototype.distinct = function<T>(this:T[]): T[] {
    return Array.from(new Set<T>(this).values());
}

export {};